import React, {useEffect, useState} from 'react';
import { Container } from '@mui/material';
import {useNavigate, useSearchParams} from 'react-router-dom';
import Button from '@mui/material/Button';
import client from "../../services/auth/ApiService/client";
import {
    MainTitle,
    OrderIntro,
    TariffAction,
    TariffCard,
    TariffContent,
    TariffFeature,
    TariffFeatures,
    TariffGrid,
    TariffImage,
    TariffText,
    TariffTitle,
} from './styles';
import memExample from '../../assets/img/mem-example1.png';
import qrExample from '../../assets/img/qr-example.png';

interface ITariff {
    id: string;
    name: string;
    price: number;
    allowFields: Record<string, boolean>;
}

const tariffImages = [memExample, qrExample];

const featureLabels: Record<string, string> = {
    epitafia: 'Эпитафия',
    bg: 'Фон в шапке',
    map: 'Отметка на карте',
    tree: 'Родственные связи',
    qr: 'QR-код для печати',
    bio: 'Биография с фото',
    gallery: 'Фотогалерея',
    media: 'Видео и аудиозаписи',
    video: 'Видео файлы',
};

const tariffDescriptions = [
    'Базовый формат для бережного сохранения главной информации о человеке: памятные слова, QR-код и основные данные, которые удобно открыть с таблички.',
    'Расширенная страница памяти с визуальной историей, родословными связями, медиа и более подробным рассказом для близких и будущих поколений.',
];

const getTariffDescription = (index: number) => tariffDescriptions[index] || tariffDescriptions[tariffDescriptions.length - 1];

const getTariffFeatures = (tariff: ITariff) => Object
    .entries(tariff.allowFields || {})
    .filter(([, enabled]) => enabled)
    .map(([key]) => featureLabels[key])
    .filter(Boolean)
    .slice(0, 5);

const OrderPage = () => {
    const navigate = useNavigate();
    const [tariff, setTariff] = useState<ITariff[]>([]);
    const [params] = useSearchParams()
    const r = params.get('r')

    useEffect(() => {
        const fetchData = async () => {
            client.get("/my-profile").then((response) => {
                const { data } = response;
                if (data?.referalPercent) {
                    navigate('/create/77dbaea6-8a97-446e-bf7c-ec6373ce9f7f')
                }
            });
        }
        fetchData();
    }, []);

    const handleOrder = async (type: string) => {
        // if (type === 'full') {
        //     await paymentSend();
        // }
        const referal = r ? `?r=${r}` : ''
        navigate('/create/' + type + referal)
    }

    useEffect(() => {
        const loadData = () => {
            if (r) {
                const type = '77dbaea6-8a97-446e-bf7c-ec6373ce9f7f';
                navigate('/create/' + type + `?r=${r}`)
            } else {
                client
                    .get(`/tariff`)
                    .then((response) => {
                        console.log(response)
                        const { data = [] } = response
                        setTariff(data)
                    })
                    .catch((error) => {
                        console.log('error')
                        console.log(error)
                    })
            }
        }
        loadData();
    }, []);

  return (
    <>
        <Container style={{marginTop: '120px', paddingLeft: '0px', paddingRight: '0px',}}>
          <MainTitle variant="h4" sx={{marginBottom: '40px'}}>Создание момента памяти</MainTitle>
            <OrderIntro>
                Выберите формат страницы памяти. Каждый вариант помогает сохранить историю человека,
                но отличается набором материалов, которые можно добавить в анкету.
            </OrderIntro>
            <TariffGrid>
                {tariff.map((item, index) => (
                    <TariffCard key={item.id}>
                        <TariffImage src={tariffImages[index % tariffImages.length]} alt={item.name} />
                        <TariffContent>
                            <TariffTitle variant="h5">{item.name}</TariffTitle>
                            <TariffText>{getTariffDescription(index)}</TariffText>
                            <TariffFeatures>
                                {getTariffFeatures(item).map((feature) => (
                                    <TariffFeature key={`${item.id}-${feature}`}>{feature}</TariffFeature>
                                ))}
                            </TariffFeatures>
                            <TariffAction>
                                <Button size="large" variant="contained" onClick={() => handleOrder(item.id)}>
                                    Создать
                                </Button>
                            </TariffAction>
                        </TariffContent>
                    </TariffCard>
                ))}
            </TariffGrid>
        </Container>
    </>
  );
}

export default OrderPage;
